/**
 * 회원탈퇴 알림봇
 */
export const accountDeleteNotifications = async (param: {
  domain: string;
  email: string;
  name: string;
  customerId: string;
  phone: string;
}) => {
  try {
    const url = `https://5vghg6y37tynis27vliesn4xtq0hekek.lambda-url.ap-northeast-2.on.aws/`; // common_account_delete
    const response = await fetch(url, { method: "POST", body: JSON.stringify(param) }).then((res) => res);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
